import * as React from 'react';
import Switch, { SwitchProps } from '@material-ui/core/Switch';
import { FieldProps } from 'formik';
import invariant from 'tiny-warning';

export interface FormikSwitchProps
    extends FieldProps,
        Omit<
            SwitchProps,
            | 'checked'
            | 'name'
            | 'value'
            | 'defaultChecked'
            | 'form'
            // Excluded for conflict with Field type
            | 'type'
        > {
    type?: string;
}

export function fieldToSwitch({
    disabled,
    field,
    form: { isSubmitting },
    type,
    ...props
}: FormikSwitchProps): SwitchProps {
    if (process.env.NODE_ENV !== 'production') {
        invariant(
            type === 'checkbox',
            `property type=checkbox is missing from field ${field.name}, this can caused unexpected behaviour`
        );
    }

    return {
        disabled: disabled ?? isSubmitting,
        ...props,
        ...field,
    };
}

export function FormikSwitch(props: FormikSwitchProps) {
    return <Switch {...fieldToSwitch(props)} />;
}
